import { useState } from "react";
import { navLinks } from "../constants/Home";
import { Link } from "react-router-dom";
import "../components/Navigation.css";
import logo from "../assets/pictures/logo.svg";
import logo2 from "../assets/pictures/logojasne.svg"
import instaIcon from "../assets/icons/instagram.svg"

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  return (
    <>
      {isOpen && <div className="overlay" onClick={closeMenu}></div>}

      <nav className="navigation-container">
        <Link to="/"><img src={logo} alt="Logo" className="logo-img" /></Link>

        <button className="hamburger" onClick={toggleMenu} aria-label="Menu">
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>

        <ul className={`navigation-list ${isOpen ? "open" : ""}`}>
          {/* Logo na górze rozwijanego menu na mobilkach */}
          <Link to="/">
            <li className="mobile-logo">
              <img src={logo2} alt="Logo" />
            </li>
          </Link>
          {navLinks.map((link) => (
            <li
              className="navigation-links"
              key={link.name}
              onClick={closeMenu}
            >
              <Link to={link.path}>{link.name}</Link>
            </li>
          ))}

          {/* Kontakt na dole rozwijanego menu (telefon + Instagram) */}
          <li className="mobile-contact">
            <a
              href="https://www.instagram.com/studio.piekne.wnetrza/"
              target="_blank"
              rel="noreferrer"
              onClick={closeMenu}
            >
               <img src={instaIcon} alt="Instagram" className="instagram-icon" />
            </a>
          </li>
        </ul>

        {/* Telefon i Instagram po prawej na desktop */}
        <div className="desktop-contact">
          <a
            href="https://instagram.com/yourprofile"
            target="_blank"
            rel="noreferrer"
          >
             <img src={instaIcon} alt="Instagram" className="instagram-icon" />
          </a>
        </div>
      </nav>
    </>
  );
};

export default Navigation;
